<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
       <span>
        <mat-form-field matTooltip="Select a Business Unit from the list" [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.AmmunitionStock.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit"              
              (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="item.businessUnit"              
              (ngModelChange)="businessUnitChanged($event)" #businessUnit              
              placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Select a Cost Centre from the list" [matTooltipDisabled]="disabledTooltip(this.costCentre)" class="crud-item-input-wider">
          <mat-label i18n="@@type.AmmunitionStock.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentre"              
              (ngModelChange)="costCentreChanging($event)" [(ngModel)]="item.costCentre"              
              (ngModelChange)="costCentreChanged($event)" #costCentre              
              placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentreDisplay(costCentre)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>

    <mat-divider></mat-divider>
  
    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Calibre" [matTooltipDisabled]="disabledTooltip(this.calibre)">
          <mat-label i18n="@@type.AmmunitionStock.calibre">Calibre</mat-label>
          <input matInput formControlName="calibre" id="calibre"              
              (ngModelChange)="calibreChanging($event)" [(ngModel)]="item.calibre"              
              (ngModelChange)="calibreChanged($event)" #calibre              
              maxlength="255" placeholder="Calibre">
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Make" [matTooltipDisabled]="disabledTooltip(this.make)">
          <mat-label i18n="@@type.AmmunitionStock.make">Make</mat-label>
          <input matInput formControlName="make" id="make"              
              (ngModelChange)="makeChanging($event)" [(ngModel)]="item.make"              
              (ngModelChange)="makeChanged($event)" #make              
              maxlength="255" placeholder="Make">
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Weight" [matTooltipDisabled]="disabledTooltip(this.weight)">
          <mat-label i18n="@@type.AmmunitionStock.weight">Weight</mat-label>
          <input matInput formControlName="weight" id="weight"              
              (ngModelChange)="weightChanging($event)" [(ngModel)]="item.weight"              
              (ngModelChange)="weightChanged($event)" #weight              
              maxlength="255" placeholder="Weight">
        </mat-form-field>
      </span>
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="closed" id="closed"              
              [(ngModel)]="item.closed" #closed i18n="@@type.AmmunitionStock.closed">
Closed          </mat-slide-toggle>        
        </span>
      </span>
      <span class="crud-editor-warning" *ngIf="item.closed && item.currentStockAmount > 0">Warning: You will not be able to close Ammunition Stock where there is a current stock amount greater than 0.</span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.AmmunitionStock.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy"              
              (ngModelChange)="createdByChanging($event)" [(ngModel)]="item.createdBy"              
              (ngModelChange)="createdByChanged($event)" #createdBy              
              maxlength="255" placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.AmmunitionStock.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate"              
              (ngModelChange)="createdDateChanging($event)" [(ngModel)]="item.createdDate"              
              (ngModelChange)="createdDateChanged($event)" #createdDate              
              [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.AmmunitionStock.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy"              
              (ngModelChange)="updatedByChanging($event)" [(ngModel)]="item.updatedBy"              
              (ngModelChange)="updatedByChanged($event)" #updatedBy              
              maxlength="255" placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.AmmunitionStock.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate"              
              (ngModelChange)="updatedDateChanging($event)" [(ngModel)]="item.updatedDate"              
              (ngModelChange)="updatedDateChanged($event)" #updatedDate              
              [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <app-ammunition-stock-event-list [ammunitionStockParent]="item" [items]="ammunitionStockEvents"></app-ammunition-stock-event-list>
    </div>

   </form>
</div>